import { useAccidentsServiceAccidentsDurationsList } from '@insurance/api/queries'
import { InputDatePicker } from '@insurance/components'
import { useValidationsField } from '@insurance/hooks'
import { getEffectiveDateRange } from '@insurance/utils'
import { Col, Form, Row, Select } from 'antd'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

import { useAccidentInsuranceValues } from './AccidentInsuranceContext'
import { formProps } from './utils'

export const Duration = () => {
  const { t } = useTranslation()
  const { required } = useValidationsField()
  const { durationProps, validFromProps, effectiveDateProps } = formProps(t)
  const { isEditable, order } = useAccidentInsuranceValues()

  const { data, isLoading } = useAccidentsServiceAccidentsDurationsList({})

  const options = data?.map(({ months }) => ({
    label: t(`m${months}`),
    value: months
  }))

  const effectiveDateRange = getEffectiveDateRange(order)

  return (
    <Row gutter={[12, 12]}>
      {!isEditable && (
        <Col xs={24} md={12}>
          <Form.Item {...validFromProps} rules={[required]}>
            <InputDatePicker minDate={dayjs()} allowClear={false} />
          </Form.Item>
        </Col>
      )}

      {isEditable && (
        <Col xs={24} md={12}>
          <Form.Item {...effectiveDateProps} rules={[required]}>
            <InputDatePicker
              minDate={effectiveDateRange.minDate}
              maxDate={effectiveDateRange.maxDate}
              allowClear={false}
            />
          </Form.Item>
        </Col>
      )}

      <Col xs={24} md={12}>
        <Form.Item {...durationProps} rules={[required]}>
          <Select
            disabled={isEditable}
            placeholder={durationProps.label}
            options={options}
            loading={isLoading}
          />
        </Form.Item>
      </Col>
    </Row>
  )
}
